import reactUpdate from 'immutability-helper';

import {BulkTranslation, TranslationSpec} from 'bulk-workflows/translation/BulkTranslationConstants';
import {SchemaField} from 'schemas/fields/SchemaFieldConstants';

export function createBulkTranslation(): BulkTranslation {
  return {
    // Input parameters
    sequenceTagSchemaId: null,
    selectedIds: [],
    translationSpecs: [],
    outputFolderId: null,
    // Input sequences. Generated by converting the user's selected folders and sequences in `selectedIds`
    // to one list of sequences.
    sequences: [],
    // Loading state
    sequencesLoading: false,
    isRunning: false,
    // Error messages from server
    errors: [],
  };
}

export function createTranslationSpec(tagSchemaField: SchemaField): TranslationSpec {
  return {
    tagSchemaField,
    firstCodonAnnotationName: '',
    firstCodonOffset: 0,
  };
}

/**
 * Immutability helpers for assemblies
 */
export const Update = {
  update(bulkTranslation: BulkTranslation, updates: Partial<BulkTranslation>): BulkTranslation {
    return reactUpdate(bulkTranslation, {$merge: updates});
  },

  updateTranslationSpec(
    bulkTranslation: BulkTranslation,
    translationSpecIndex: number,
    updates: Partial<TranslationSpec>
  ): BulkTranslation {
    return reactUpdate(bulkTranslation, {translationSpecs: {[translationSpecIndex]: {$merge: updates}}});
  },
};

export function getErrors(bulkTranslation: BulkTranslation): Array<string> {
  const errors = [];
  if (!bulkTranslation.sequenceTagSchemaId) {
    errors.push('A sequence schema is required');
  }
  if (!bulkTranslation.outputFolderId) {
    errors.push('A target folder is required');
  }
  return errors.concat(bulkTranslation.errors);
}

export function getProteinNames(bulkTranslation: BulkTranslation): Array<string> {
  const proteinNames: Array<string> = [];
  bulkTranslation.sequences.forEach((sequence) => {
    bulkTranslation.translationSpecs
      .filter((translationSpec) => translationSpec.firstCodonAnnotationName.length > 0)
      .forEach((translationSpec) => {
        proteinNames.push(`${sequence.name}-${translationSpec.tagSchemaField.name}`);
      });
  });
  return proteinNames;
}
